import { render } from "./DayList.vue?vue&type=template&id=062ff216&scoped=true"
import script from "./DayList.vue?vue&type=script&lang=js"
export * from "./DayList.vue?vue&type=script&lang=js"

import "./DayList.vue?vue&type=style&index=0&id=062ff216&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062ff216"]])

export default __exports__